var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import fetch from '../../common/fetch';
var defaultConfig = {
    apiPath: '/index/acceptcookies',
};
var AcceptCookiesClient = /** @class */ (function () {
    function AcceptCookiesClient(config) {
        if (config === void 0) { config = {}; }
        this.config = __assign(__assign({}, defaultConfig), config);
    }
    AcceptCookiesClient.prototype.accept = function (prefix) {
        var url = "" + (prefix || '') + this.config.apiPath;
        return fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
    };
    return AcceptCookiesClient;
}());
export default AcceptCookiesClient;
